import React, { useEffect } from 'react';
import { useModalAnimation } from '../../hooks/useModalAnimation';
import { X } from 'lucide-react';
import { createPortal } from 'react-dom';

export const Modal = ({ isOpen, onClose, title, children, maxWidth = "max-w-2xl" }) => {
    const { isVisible, isClosing, handleAnimationEnd } = useModalAnimation(isOpen, onClose);

    useEffect(() => {
        const handleEsc = (e) => {
            if (e.key === 'Escape') {
                if (typeof onClose === 'function') onClose();
            }
        };
        if (isOpen) window.addEventListener('keydown', handleEsc);
        return () => window.removeEventListener('keydown', handleEsc);
    }, [isOpen, onClose]);

    if (!isVisible) return null;

    return createPortal(
        <div
            className={`fixed inset-0 z-[100] flex items-center justify-center bg-black/70 backdrop-blur-sm p-4 ${isClosing ? 'animate-out fade-out duration-200' : 'animate-in fade-in duration-200'}`}
            onAnimationEnd={handleAnimationEnd}
        >
            <div className={`bg-stone-900 border border-stone-700 rounded-xl shadow-2xl w-full ${maxWidth} flex flex-col max-h-[90vh] ${isClosing ? 'animate-out zoom-out-95 duration-200' : 'animate-in zoom-in-95 duration-200'}`}>
                <div className="flex justify-between items-center p-4 border-b border-stone-700 shrink-0">
                    <h3 className="text-lg font-bold text-stone-200">{title}</h3>
                    <button onClick={() => typeof onClose === 'function' && onClose()} className="text-stone-500 hover:text-white transition-colors">
                        <X size={20} />
                    </button>
                </div>
                <div className="flex-1 overflow-y-auto p-6">
                    {children}
                </div>
            </div>
        </div>,
        document.body
    );
};
